// PLUGINS IMPORTS //
import React from "react"
import styled from "styled-components"

// COMPONENTS IMPORTS //
import { AboutNavigationItemType } from "../SideNavigator"
import { memoComparison } from "Content/Shared/Helpers/Functions/Functions"

// EXTRA IMPORTS //

/////////////////////////////////////////////////////////////////////////////

type PropsType = {
  item: AboutNavigationItemType
  isSelected: boolean
}

const NavItem: React.FC<PropsType> = (props) => {
  return (
    <Wrapper isSelected={props.isSelected}>
      <i className={props.item.icon} />
    </Wrapper>
  )
}

/////////////////////////////////////////////////////////////////////////////

const Wrapper = styled.div`
  border-right: ${(props: { isSelected: boolean }) =>
    `${props.isSelected ? "3px" : undefined}  solid white`};
  color: ${(props: { isSelected: boolean }) =>
    props.isSelected ? "white" : "#858585"};

  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  cursor: pointer;
  transition: 0.2s ease;

  :hover {
    background-color: #3d4991;
    transform: scale(1.07);
  }
`

export default React.memo(NavItem, memoComparison)
